import { QRCode } from "antd";
import React from "react";
import Helper from "../Helper";
import { CommandProjectInfo } from "./CommandTypes";
import { JobsiteCommandContext } from "./JobsiteCommandProvider";
import JobsiteHours from "./jobsiteHoursUI";

interface CommandCenterQRCodeCardProps {
    url: string;
    projectInfo: CommandProjectInfo;
}

const CommandCenterQRCodeCard: React.FC<CommandCenterQRCodeCardProps> = ({ url, projectInfo }) => {
    const commandContext = React.useContext(JobsiteCommandContext);
    const isPortrait = commandContext?.isPortrait ?? false;

    const card = (
        <div
            className={Helper.classNames(
                "flex items-center justify-center p-4 rounded-lg shadow-sm",
                isPortrait ? "flex-col" : "flex-row border bg-neutral-800 border-neutral-700"
            )}
        >
            <div className="flex flex-row items-center">
                <QRCode
                    value={url}
                    icon="/img/png/logo/PLOT-P.png"
                    bgColor="transparent"
                    color="#FFFFFF"
                    className="h-full w-full max-w-full"
                />
            </div>

            <div className="text-xl text-neutral-100 font-semibold leading-tight text-center">
                SCAN TO BOOK A DELIVERY AS GUEST
            </div>
        </div>
    );

    return (
        <div className={Helper.classNames("flex flex-col shrink-0", isPortrait ? "w-fit" : "w-full")}>
            {isPortrait && (
                <JobsiteHours project={projectInfo} iconSize="xl" headerSize="text-lg" secondaryColor="#ffffff" />
            )}

            {card}
        </div>
    );
};

export default CommandCenterQRCodeCard;
